import { Routes } from '../../../route/Routes';
import { Center, Container, Flex } from '@mantine/core';
import classes from './LandingPage.module.css';
import { Navigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useKeycloakStore } from '../../../store';

import {
  AboutUs,
  Contact,
  Cooperations,
  FAQShort,
  HowItWorks,
  Intro,
  LocationWrapper,
  Testimonials,
} from './sections';
import {
  CohortEndingBanner,
  Loading,
  OpeningHoursBanner,
} from '../../../component';
import { LandingPageHeader } from '../navigation';
import { JoinAndProfit } from './sections/JoinAndProfit';
import { useWindowSize } from '../../../hooks';
import { FeatureAccess } from '../../../util/ff/FeatureAccess';
import { TelegramChannelBanner } from '../../../component/banner/TelegramChannelBanner';
import { FeatureFlag } from '@web/common';
import { InstagramBanner } from '../../../component/banner/InstagramBanner';
import { Products } from './sections/Products';

export const LandingPage = observer(() => {
  const kcStore = useKeycloakStore();
  const isSmallScreen = useWindowSize(600);

  if (!kcStore.initialized && !kcStore.initializingInProgress) {
    kcStore.initKeycloak();
    return <Loading />;
  }

  if (kcStore.authenticated) {
    return <Navigate to={Routes.Study} />;
  }

  return (
    <Container
      fluid
      className={classes.container}
      p={0}
      style={{ overflow: 'clip' }}
    >
      <LandingPageHeader />
      <Center>
        <Flex className={classes.sectionWrapper}>
          {!isSmallScreen && (
            <CohortEndingBanner padding="20px 20px 0px 20px" />
          )}
          <OpeningHoursBanner />
          <Flex
            maw="1100px"
            wrap="wrap"
            m={isSmallScreen ? '-5px' : '-30px 0px'}
          >
            <FeatureAccess flag={FeatureFlag.BannerTelegramChannel}>
              <Flex flex="1 1 300px">
                <TelegramChannelBanner />
              </Flex>
            </FeatureAccess>
            <FeatureAccess flag={FeatureFlag.BannerInstagramChannel}>
              <InstagramBanner />
            </FeatureAccess>
          </Flex>
          <Intro id="intro" />
          {isSmallScreen && <CohortEndingBanner padding="20px" />}
          <JoinAndProfit id="joinandprofit" />
          <Cooperations />
          <HowItWorks id="howitworks" />
          <Products id="products" />
          <LocationWrapper id="locations" />
          <FAQShort id="faq" />
          <Testimonials />
          <AboutUs id="aboutus" />
          <Contact id="contact" />
        </Flex>
      </Center>
    </Container>
  );
});
